// using decimal.js for now because prisma's was trying to access `process` on client-side for some reason
import { Decimal } from "decimal.js";
import { z } from "zod";
import { assetClassValues, currencyValues } from "../gql/client/enumValues";
export const dateSchema = z
    .instanceof(Date)
    .or(z.string())
    .pipe(z.coerce.date());
// if Decimal.js's constructor accepts it; it's a valid serialisation of Decimal
// - note, no longer following https://github.com/colinhacks/zod/issues/397#issuecomment-826249738 because it doesn't support server-side parsing Decimals that come direct from Prisma
// - not ideal for compile time type safety (e.g. inferred type will always say "yeah it's a decimal", even if it's not a valid one)
export const decimalSchema = z
    .custom(Decimal.isDecimal)
    .or(z.any())
    .refine((value) => {
    try {
        return new Decimal(value);
    }
    catch {
        return false;
    }
})
    .transform((value) => new Decimal(value));
export const currencySchema = z.enum(currencyValues);
export const assetClassSchema = z.enum(assetClassValues);
export const unitPriceSchema = z.object({
    price: decimalSchema,
    at: dateSchema,
    updatedAt: dateSchema,
});
const unitPriceHistorySchema = z.array(unitPriceSchema).min(1);
export const unitPriceHistoryInCurrencySchema = z.object({
    currency: currencySchema,
    unitPriceHistory: unitPriceHistorySchema,
});
export const logoSchema = z
    .discriminatedUnion("kind", [
    z.object({ kind: z.literal("key"), key: z.string() }),
    z.object({ kind: z.literal("url"), url: z.string() }),
])
    .nullable();
export const currencyAmountSchema = z.object({
    amount: decimalSchema,
    currency: currencySchema,
});
export const balanceDataPointSchema = z.object({
    at: dateSchema,
    currencyBalances: z.array(currencyAmountSchema),
});
export const currencyAmountLineSeriesSchema = z.object({
    id: z.string(),
    label: z.string(),
    targetCurrency: currencySchema,
    points: z.array(balanceDataPointSchema),
});
export const currencyAmountLineChartSchema = z.object({
    id: z.string(),
    series: z.array(currencyAmountLineSeriesSchema),
});
